module.exports = __webpack_public_path__ + "img/footer-logo-cn.8b2777f0.png";